import styled from 'styled-components';

import { PrsInput } from '../../styles-and-themes/styles/prsInputs';

export const PasswordFieldWrap = styled.div`
  position: relative;
  width: 100%;
`;

export const PasswordInput = styled(PrsInput)`
  padding-right: 40px;
`;

export const ToggleVisibility = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #69686f;
  display: flex;
  align-items: center;
`;

// <ul>/<li> swap for AT navigation; UA list defaults are stripped so the
// rendered pixels match the previous div/span layout exactly.
export const RequirementsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Requirement = styled.li`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  line-height: 20px;
  list-style: none;

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ $met }) => ($met ? '#1a8c5c' : '#cbcacc')};
    flex-shrink: 0;
  }
`;

export const LockoutTimer = styled.p`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #a30283;
  margin: 16px 0;
`;
